import { inject, Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { ApiService } from "./api.service";

@Injectable({
  providedIn: 'root'
})
export class PlayerService {
  private _apiService: ApiService = inject(ApiService);

  constructor() { }

  getPlayer(id: string): Observable<any> {
    return this._apiService.get(`/players/${id}/`, undefined, true);
  }
}
